import groq from 'groq';

import { ASSET, RICH_TEXT } from '../common';

export const RICH_TABLE_CELL = groq`
  _key,
  _type,
  cellType,
  text,
  tooltipLabel,
  tooltipContent,
  "pageFootnotes": footnotes[]-> {
     name,
     content
  },
  thumbnail -> {
    _id,
    title,
    "slug": slug.current,
    thumbnail { ${ASSET} }
  }
`;

export const RICH_TABLE = groq`
  _key,
  _type,
  title,
  rows[] {
    _key,
    _type,
    cells[] { ${RICH_TABLE_CELL} }
  },
  "highlightedCol": highlightedCol - 1,
  "highlightedRow": highlightedRow - 1
`;

export const COMPARISON_TABLE = groq`
  _type,
  variant,
  eyebrow,
  "isBackgroundVisible": coalesce(isBackgroundVisible, true),
  description[] {
    ${RICH_TEXT}
  },
  "isCollapsible": coalesce(isCollapsible, false),
  backgroundImage {
    ${ASSET},
  },
  isDarkMode,
  richTables[] {
    ${RICH_TABLE}
  },
  tableToggle {
    title,
    labels[]
  }
`;

export const COMPARISON_TABLE_BLOCK = groq`
  _type == 'comparisonTable' => @ -> {
    ${COMPARISON_TABLE}
  }
`;
